<template>
  <div class="grid-container">
    <div class="action action--page">
      <template v-if="showPrevButton">
        <router-link
          v-if="prevButtonRouter"
          :to="prevButtonRouter"
          tag="button"
          class="button button--prev"
          :title="$t('prev_page')"
          tabindex="-1"
        >{{ $t('prev_page') }}</router-link>
        <button
          v-else
          role="button"
          class="button button--prev"
          :title="$t('prev_page')"
          @click="onClickPrevAction"
          tabindex="-1"
        >{{ $t('prev_page') }}</button>
      </template>
      <h1 v-if="title" :class="{'u-no-margin--bottom': $slots.default}">{{ title }}</h1>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    showPrevButton: {
      type: Boolean,
      default: true
    },
    prevButtonRouter: {
      type: Object
    }
  },
  methods: {
    onClickPrevAction: function() {
      var current = this.$route;
      var history = this.$helpers.history;

      if (history) {
        if (
          current.name.search("update") !== -1 &&
          history.name.search("create") !== -1
        ) {
          this.$router.go(-2);
        } else if (
          current.name.search("update") !== -1 &&
          history.name.search("duplicate") !== -1
        ) {
          this.$router.go(-2);
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>